/*
 * @Author: miaoqing6
 * @Date: 2025-03-03 16:21:00
 * @LastEditors: miaoqing6
 * @Date: 2025-03-03 16:21:00
 * @Description: file content
 */
import lodash from 'lodash';
import { BindAll } from 'lodash-decorators';
import { EnumAPI } from '../../apis';
import { BasesController } from '../bases';

@BindAll()
export class BusinessPriceQuotationProductController<
  T = any,
> extends BasesController<T> {
  constructor() {
    super();
    this.reset({
      dataKey: 'productSn',
      pagination: EnumAPI.business_priceQuotationReview_productList,
      paginationParams: {
        currentKey: 'pageNo',
        pageSizeKey: 'pageSize',
        filterKey: 'search',
        response: {
          dataSource: 'list',
          total: 'count',
          //   valueGetter: this.valueGetter,
        },
      },
    });
  }
  valueGetter(res) {
    const dataSource = lodash.get(res, 'records');
    const total = lodash.get(res, 'total');
    return {
      dataSource,
      total,
    };
  }
}
